import React, { Component } from 'react'

const defaultMedications = [
  {
    name: 'Lamictal (lamotrigine)',
    baseline: '100 mg',
    previous: '100 mg',
    latest: 'Not listed',
    change: 'Increased',
  },
  {
    name: 'Vraylar (cariprazine)',
    baseline: '1.5 mg',
    previous: '1.5 mg',
    latest: '1.5 mg',
    change: 'Stayed the same',
  },
  {
    name: 'Lithium',
    baseline: 'Not listed',
    previous: '100mg',
    latest: '100 mg',
    change: 'Added',
  },
]

class MedicationComparison extends Component {
  render() {
    const medications =
      this.props.medications || defaultMedications

    const latestDate =
      this.props.latestDate ||
      'August 10, 2026'

    const latestTimepoint =
      this.props.latestTimepoint || 5

    const previousDate =
      this.props.previousDate ||
      'May 27, 2026'

    const previousTimepoint =
      this.props.previousTimepoint || 2

    return (
      <div className="small-12 columns">
        <div className="title6">Medication Comparison</div>

        <p>
          <strong>Latest medication assessment:</strong>{' '}{latestDate}<br />
          <strong>Previous medication assessment:</strong>{' '}{previousDate}
        </p>

        <table>
          <thead>
            <tr>
              <th>Medication</th>
              <th>Now</th>
              <th>Previous</th>
              <th>At Enrollment</th>
            </tr>
          </thead>

          <tbody>
            {medications.map(medication => (
              <tr key={medication.name}>
                <td>{medication.name}</td>
                <td>{medication.latest}</td>
                <td>{medication.previous}</td>
                <td>{medication.baseline}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default MedicationComparison
